import React, { useState } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { FaPlus, FaTrash, FaEdit } from 'react-icons/fa';

const ManualLinkInput = ({ 
  manualLinks = [], 
  onChange, 
  disabled = false 
}) => {
  const [newLink, setNewLink] = useState({ url: '', type: 'unknown', custom_name: '' });
  const [editingIndex, setEditingIndex] = useState(null);

  const handleAddLink = () => {
    if (newLink.url.trim()) {
      const updatedLinks = [...manualLinks, { ...newLink }];
      onChange(updatedLinks);
      setNewLink({ url: '', type: 'unknown', custom_name: '' });
    }
  };

  const handleRemoveLink = (index) => {
    const updatedLinks = manualLinks.filter((_, i) => i !== index);
    onChange(updatedLinks);
  };

  const handleLinkChange = (index, field, value) => {
    const updatedLinks = [...manualLinks];
    updatedLinks[index] = { ...updatedLinks[index], [field]: value };
    onChange(updatedLinks);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddLink();
    }
  };

  return (
    <div style={{ width: '100%' }}>
      {/* Existing Links */}
      {manualLinks.map((link, index) => (
        <div key={index} className="selected-document d-flex align-items-center mb-2 p-2 border rounded">
          {editingIndex === index ? (
            <div className="flex-grow-1">
              <Form.Control
                type="text"
                value={link.custom_name}
                onChange={(e) => handleLinkChange(index, 'custom_name', e.target.value)}
                placeholder="Custom name (optional)"
                size="sm"
                className="mb-2"
              />
              <Form.Control
                type="url"
                value={link.url}
                onChange={(e) => handleLinkChange(index, 'url', e.target.value)}
                placeholder="https://example.com/manual.pdf"
                size="sm"
                className="mb-2"
              />
              <Form.Select
                value={link.type}
                onChange={(e) => handleLinkChange(index, 'type', e.target.value)}
                size="sm"
                className="mb-2"
              >
                <option value="unknown">Type...</option>
                <option value="Service Manual">Service Manual</option>
                <option value="User Manual">User Manual</option>
                <option value="Training Document">Training Document</option>
                <option value="Technical Specs">Technical Specs</option>
                <option value="Schematics">Schematics</option>
                <option value="Datasheet">Datasheet</option>
              </Form.Select>
              <div className="text-end">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => setEditingIndex(null)}
                >
                  Save Changes
                </Button>
              </div>
            </div>
          ) : (
            <>
              <div className="flex-grow-1">
                <div className="d-flex align-items-center">
                  <strong>{link.custom_name || (link.url ? link.url.split('/').pop() || 'Manual Link' : 'Manual Link')}</strong>
                  {link.type && link.type !== 'unknown' && (
                    <span className="badge bg-primary ms-2">{link.type}</span>
                  )}
                </div>
                {link.url && (
                  <div style={{ fontSize: '0.85em', color: '#666', marginTop: '2px' }}>
                    {link.url.length > 60 ? `${link.url.substring(0, 60)}...` : link.url}
                  </div>
                )}
              </div>
              <div className="d-flex align-items-center">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setEditingIndex(index)}
                  disabled={disabled}
                  className="me-2 d-flex align-items-center justify-content-center"
                  title="Edit Link"
                  style={{ height: '32px', width: '32px', padding: 0 }}
                >
                  <FaEdit />
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => handleRemoveLink(index)}
                  disabled={disabled}
                  className="d-flex align-items-center justify-content-center"
                  title="Remove Link"
                  style={{ height: '32px', width: '32px', padding: 0 }}
                >
                  <FaTrash />
                </Button>
              </div>
            </>
          )}
        </div>
      ))}

      {/* Add New Link */}
      <div className="d-flex gap-2 mb-3">
        <Form.Control
          type="url"
          placeholder="https://example.com/manual.pdf"
          value={newLink.url}
          onChange={(e) => setNewLink(prev => ({ ...prev, url: e.target.value }))}
          onKeyPress={handleKeyPress}
          disabled={disabled}
        />
        <Button
          variant="outline-primary"
          onClick={handleAddLink}
          disabled={disabled || !newLink.url.trim()}
          style={{ width: '40px', height: '40px', padding: 0 }}
        >
          <FaPlus />
        </Button>
      </div>
    </div>
  );
};

export default ManualLinkInput; 